import React from "react";

export const Progress = (props)=> {

    return (
        <div className={`absolute top-0 left-0 mx-auto bg-main-700 h-[10px] rounded-tl-[10px] ${props.width ? `${props.width}`:'w-full rounded-t-[10px]'} `}>
        {/* {typeof props.width}% */}
        </div>
    )
}